
export class Metadata {
    field: string;
    totalCount: number;
    values: Array<string>;

    constructor(value?: Partial<Metadata>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}